/** Timeout breve per bootstrap (home, mappa, config) — evita caricamento infinito. */
export const API_BOOTSTRAP_TIMEOUT_MS = 5000;

/**
 * Attende al massimo `ms`; risolve con `fallback` se la promise non conclude in tempo.
 */
export function withTimeout(promise, ms, fallback = null) {
  let timer;
  const timeout = new Promise((resolve) => {
    timer = setTimeout(() => resolve(fallback), ms);
  });
  return Promise.race([promise, timeout]).finally(() => {
    if (timer) clearTimeout(timer);
  });
}

/**
 * Esegue fn; in caso di errore o timeout restituisce fallback.
 */
export async function safeApiCall(fn, { timeoutMs = API_BOOTSTRAP_TIMEOUT_MS, fallback = null } = {}) {
  try {
    return await withTimeout(Promise.resolve().then(fn), timeoutMs, fallback);
  } catch {
    return fallback;
  }
}
